import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { FeeSubProductDTO } from "@models/platform-analysis/entities/steps/fee";
import { Text, View } from "@react-pdf/renderer";
import { isEmpty } from "lodash";

export const PDFFeeLineChartSubProduct = ({
  subProducts,
  colors,
}: {
  subProducts: FeeSubProductDTO[];
  colors: Record<string, string>;
}) => {
  const { typographyStyle } = useAnalysisPDFStyles();

  return (
    <View
      style={{
        marginTop: 5,
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        gap: 10,
      }}
    >
      {subProducts?.map((subProduct: FeeSubProductDTO, index: number) => {
        return (
          <View
            key={index}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: -1,
              }}
            >
              <View
                style={{
                  width: 7,
                  height: 2,
                  backgroundColor: colors[subProduct.id],
                }}
              ></View>
              <View
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: 5,
                  backgroundColor: colors[subProduct.id],
                }}
              ></View>
              <View
                style={{
                  width: 7,
                  height: 2,
                  backgroundColor: colors[subProduct.id],
                }}
              ></View>
            </View>
            <View style={{ textAlign: "left" }}>
              {!isEmpty(subProduct.productName) && (
                <Text
                  style={{
                    ...typographyStyle.body2,
                    lineHeight: isEmpty(subProduct.name) ? 0.8 : 1.2,
                    maxWidth: 100,
                    fontWeight: "bold",
                  }}
                >
                  {`${subProduct.productName} `}
                </Text>
              )}

              {!isEmpty(subProduct.name) && (
                <Text
                  style={{
                    ...typographyStyle.body2,
                    lineHeight: 1.2,
                    maxWidth: 100,
                  }}
                >
                  {`${subProduct.name}${
                    !subProduct.isLatest && subProduct.outdatedAt
                      ? ` (Outdated)`
                      : ""
                  }`}
                </Text>
              )}
            </View>
          </View>
        );
      })}
    </View>
  );
};
